import "./TermsOfUse.module.css";
import Header from "@/reusable_sections/Header";
import TermsOfService from "./sections/TermsOfService";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfUsePage() {
  return <div>
      <Header />
      <TermsOfService />
      <Footer />
    </div>;
}